<ag-grid-angular
  class="ag-theme-material"
  [ngStyle]="{ height }"
  [class.row-hover]="rowHover"
  [animateRows]="true"
  [autoGroupColumnDef]="autoGroupColumnDef"
  [columnDefs]="columnDefs"
  [context]="context"
  [defaultColDef]="defaultColDef"
  [getContextMenuItems]="getContextMenuItems"
  [getDataPath]="getDataPath"
  [getLocaleText]="getLocaleText"
  [getRowId]="getRowId"
  [gridOptions]="gridOptions"
  [groupDefaultExpanded]="groupDefaultExpanded"
  [isRowSelectable]="isRowSelectable"
  [rowClassRules]="rowClassRules"
  [rowData]="rowData"
  [rowSelection]="rowSelection"
  [sideBar]="sideBar"
  [statusBar]="statusBar"
  [suppressRowClickSelection]="suppressRowClickSelection"
  [suppressScrollOnNewData]="suppressScrollOnNewData"
  [treeData]="treeData"
  (cellClicked)="cellClicked($event)"
  (cellEditingStopped)="cellEditingStopped($event)"
  (columnMoved)="saveState()"
  (columnResized)="saveState()"
  (columnVisible)="saveState()"
  (filterChanged)="saveFilters()"
  (firstDataRendered)="onFirstDataRendered($event)"
  (gridReady)="onGridReady($event)"
  (rowClicked)="rowClicked($event)"
  (rowSelected)="onRowSelected($event)"
  (selectionChanged)="selectionChanged($event)"
  (sortChanged)="saveState()"
>
</ag-grid-angular>

